<app-view-item
  *ngIf="readonly"
  [text]="value"
  [borderless]="borderless"
></app-view-item>

<input
  *ngIf="!readonly"
  nz-input
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  [readOnly]="readonly"
  (keydown)="onKeydown($event)"
  (keyup)="onKeyUp($event)"
  (paste)="onPaste($event)"
  autocorrect="off"
  autocomplete="off"
  spellcheck="false"
  [disabled]="!this.isEnabled"
  [placeholder]="this.placeHolder"
  [class]="readonly && !borderless ? 'bg-grey-lighter' : ''"
  [maxlength]="this.maxChar"
  [required]="this.isRequired"
  (click)="onClick($event.target)"
  style="width: 100% !important"
/>
